import {
  useTheme,
  Container,
  Box,
  Stack,
  Typography,
  Button,
  alpha,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import {
  ArrowForwardRounded,
  ArrowBackRounded,
  SaveAltOutlined,
} from "@mui/icons-material";
import { grey } from "@mui/material/colors";

const StepperContent = ({
  title,
  activeStepNumber = 1,
  stepsCount = 8,
  nextDisabled = false,
  backDisabled = false,
  onNext,
  onBack,
  onComplete,
  children,
  saving = false,
  popupMode = false,
  disabled = false,
}) => {
  const theme = useTheme();
  const stepPercentage = Math.round((activeStepNumber / stepsCount) * 100);

  return (
    <Stack gap={2}>
      <Box position="sticky" top={0} zIndex={10}>
        <Box
          py={2}
          pt={3}
          sx={{
            bgcolor: "background.paper",
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
            ...theme.applyStyles("dark", {
              borderBottomColor: "background.paper2",
            }),
          }}
        >
          <Typography
            variant="h3"
            pt={1}
            textAlign="center"
            sx={{
              color: "text.mediumDark",
              ...theme.applyStyles("dark", {
                color: "#fff",
              }),
            }}
          >
            {title}
          </Typography>

          {popupMode === false && (
            <Box
              display="flex"
              justifyContent="flex-end"
              marginTop="-30px"
              marginRight="15px"
            >
              <LoadingButton
                variant="contained"
                color="secondary"
                startIcon={<SaveAltOutlined />}
                onClick={onComplete}
                loading={saving}
                disabled={disabled}
              >
                Save Changes
              </LoadingButton>
            </Box>
          )}
        </Box>
      </Box>
      {children}
      <Container maxWidth="xs">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Button
            variant="text"
            size="small"
            startIcon={<ArrowBackRounded />}
            sx={{
              color: grey[600],
            }}
            disabled={backDisabled}
            onClick={onBack}
          >
            Back
          </Button>
          {activeStepNumber >= stepsCount ? (
            <LoadingButton
              variant="contained"
              color="secondary"
              size="small"
              onClick={onComplete}
              loading={saving}
              disabled={disabled}
            >
              {popupMode ? "Complete" : "Save"}
            </LoadingButton>
          ) : (
            <LoadingButton
              variant="contained"
              color="secondary"
              size="small"
              endIcon={<ArrowForwardRounded />}
              disabled={nextDisabled || disabled}
              loading={saving}
              onClick={async () => {
                const saved = await onComplete?.();
                if (saved !== false) {
                  onNext();
                }
              }}
            >
              Next
            </LoadingButton>
          )}
        </Stack>
      </Container>
    </Stack>
  );
};

export default StepperContent;
